module.exports = __webpack_public_path__ + "img/img.5c87931c.png";